"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductsInnerProductCollectionsInnerToJSON = exports.ProductsInnerProductCollectionsInnerFromJSONTyped = exports.ProductsInnerProductCollectionsInnerFromJSON = exports.instanceOfProductsInnerProductCollectionsInner = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the ProductsInnerProductCollectionsInner interface.
 */
function instanceOfProductsInnerProductCollectionsInner(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfProductsInnerProductCollectionsInner = instanceOfProductsInnerProductCollectionsInner;
function ProductsInnerProductCollectionsInnerFromJSON(json) {
    return ProductsInnerProductCollectionsInnerFromJSONTyped(json, false);
}
exports.ProductsInnerProductCollectionsInnerFromJSON = ProductsInnerProductCollectionsInnerFromJSON;
function ProductsInnerProductCollectionsInnerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'storeId': !(0, runtime_1.exists)(json, 'store_id') ? undefined : json['store_id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'position': !(0, runtime_1.exists)(json, 'position') ? undefined : json['position'],
    };
}
exports.ProductsInnerProductCollectionsInnerFromJSONTyped = ProductsInnerProductCollectionsInnerFromJSONTyped;
function ProductsInnerProductCollectionsInnerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'store_id': value.storeId,
        'name': value.name,
        'position': value.position,
    };
}
exports.ProductsInnerProductCollectionsInnerToJSON = ProductsInnerProductCollectionsInnerToJSON;
